import Api from '@/services/api';
import qs from 'querystring';

export default {
 
  getContexts() {
    return Api().get('/translations/contexts');
  },
  getActiveLanguages() {
    return Api().get('/translations/languages');
  },
  getContext(id) {
    return Api().get('/translations/context/' + id);
  },
  addContext(post) {
    return Api().post('/translations/context/add', qs.stringify( {
      label: post.label,
      description: post.description,
      slug: post.slug
    }));
  },
  addLabel(post) {
    return Api().post('/translations/context/label/add', qs.stringify( {
      label: post.label,
      contextID: post.contextID
    }));
  },
  deleteLabel(post) {
    return Api().post('/translations/context/label/delete', qs.stringify( {
      label: post.label,
      contextID: post.contextID
    }));
  },
  save(post) {
    return Api().post('/translations/save',  qs.stringify( 
      {
        post: post
      })
    );
  },
  suggestion(post) {
    return Api().post('/translations/suggestion', qs.stringify(
      {
        ID: post.ID,
        source: post.source,
        target: post.target,
        text: post.text
      }
    ));
  },
  selectLanguages(post) {
    return Api().post('/translations/select-languages', qs.stringify(
      {
        selected: JSON.stringify(post.selected)
      }
    ));
  }
}